import dayjs from "dayjsConfig";
import Typography from "@mui/material/Typography";
import React from "react";

type CurrentSvadbaTimeProps = {
	variant?: "caption" | "body2" | "body1";
	showSeconds?: boolean;
};

const CurrentSvadbaTime: React.FC<CurrentSvadbaTimeProps> = ({
	variant = "body2",
	showSeconds = false,
}) => {
	const timeFormat = showSeconds ? "MMM D, YYYY HH:mm:ss" : "MMM D, YYYY HH:mm";
	const [display, setDisplay] = React.useState(() => {
		const now = dayjs().tz("America/New_York");
		return { text: now.format(timeFormat), tz: now.format("z") };
	});

	React.useEffect(() => {
		const tick = showSeconds ? 1000 : 10_000;
		const intervalId = window.setInterval(() => {
			const now = dayjs().tz("America/New_York");
			const text = now.format(timeFormat);
			setDisplay((prev) => {
				if (prev.text === text) return prev;
				return { text, tz: now.format("z") };
			});
		}, tick);
		return () => window.clearInterval(intervalId);
	}, [showSeconds, timeFormat]);

	return (
		<Typography
			variant={variant}
			sx={{
				color: "text.secondary",
				whiteSpace: "nowrap",
			}}
		>
			{`Current Svadba time: ${display.text} ${display.tz}`}
		</Typography>
	);
};

export default CurrentSvadbaTime;
